var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"position-absolute pos-bottom pos-left pos-right p-3 text-center"},[_vm._v("\n  2019 © "+_vm._s(_vm.appTitle)+" by \n")])}
var staticRenderFns = []

export { render, staticRenderFns }